import React from 'react';

const LazyRodeoEventLeaderBoard = React.lazy(() =>
    import('./forgot-password')
);

const ForgotPassword = (props: Record<string, any>) => (
    <React.Suspense fallback={<h1>Loading...</h1>}>
        <LazyRodeoEventLeaderBoard {...props} />
    </React.Suspense>
);

export default ForgotPassword